// eslint-disable-next-line import/no-anonymous-default-export
export default {
  installation: {
    common: {
      update: "更新",
      packageInformation: "安装包信息",
      packageUpload: "安装包上传",
      packageName: "安装包名称",
      productName: "产品名称",
      sku: "版本",
      version: {
        community: "社区版",
        enterprise: "企业版",
      },
      versionId: "版本号",
      publishTime: "发布时间",
      robot: "机器人",
      studio: "编辑器",
      android: "安卓",
      ios: "IOS",
      appium: "安卓V2（Beta）",
      ocr: "离线OCR",
      fileName: "文件名称",
      fileSize: "文件大小",
      uploadByName: "创建人",
      notUpload: "未上传",
      uploadFailed: "{fileName} {type} 上传失败",
      uploadSuccessfully: "{fileName} {type} 上传成功",
      mainFile: "主文件",
      extFile: "额外文件",
      mainTip: "请上传以下1个主文件，例：{file}",
      extTip: "以及以下2个额外文件，例：{extOne}和{extTwo}",
      errorSuffix: "已存在 {suffix} 文件，请先删除！",
      errorAllowed: "{file}是不被允许的文件类型",
      firstRemove: "请先删除额外文件",
      create: "创建",
      publish: "发布",
      publishPackage: "是否发布当前安装包: {package}？",
      publishSuccessfully: "发布成功",
      createSuccessfully: "创建成功",
      deleteSuccessfully: "删除成功",
      deleteInstation: "确定删除 {name} ？",
      inComplete: "上传的文件不完整，请继续上传",
      tip: "若想替换当前文件，请直接上传进行覆盖",
    },
    input: {
      packageName: "请输入安装包名称",
      sku: "请选择版本",
    },
  },
};
